import AppDispatcher from './appDispatcher';
export default (function (actionType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var name = arguments.length > 2 ? arguments[2] : undefined;
  AppDispatcher.dispatch({
    action: {
      actionType: actionType,
      data: data,
      name: name
    }
  });
});